var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.427 16.3918C27.2495 13.5979 29.9932 8.17775 26.0035 1.26562C20.0133 7.31722 9.11152 10.2788 6.54672 15.4363C1.29976 25.9693 12.1345 31.2498 17.2138 29.54C16.4092 28.5006 12.0116 20.8788 21.427 16.3918Z",
    fill: "#C4D5D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8405 18.365C28.1995 17.1748 32.2562 12.6431 30.2223 4.9375C22.8687 9.23453 11.5757 9.27364 7.75926 13.5874C-0.0580807 22.405 9.03328 30.3062 14.3864 29.9709C13.8779 28.7639 11.5981 20.2593 21.8405 18.365Z",
    fill: "#8FAEB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.0568 33.561C9.2399 36.3549 6.49628 41.7807 10.486 48.6928C16.4761 42.6412 27.3779 39.6741 29.9427 34.5221C35.1897 23.9891 24.3549 18.7086 19.2756 20.4185C20.0747 21.4522 24.4779 29.0796 15.0568 33.561Z",
    fill: "#E1CDD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.6274 31.5982C8.29085 32.766 4.2341 37.3201 6.296 45.0089C13.6496 40.7119 24.8587 40.5778 28.759 36.359C36.5484 27.5582 27.4571 19.657 22.1039 19.9699C22.6124 21.1992 24.8867 29.7039 14.6274 31.5982Z",
    fill: "#CBB0BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7057 29.5883C8.28527 29.0798 3.18359 32.4269 3.18359 40.4007C11.3977 38.1656 22.3163 41.0433 27.1162 37.8638C36.9284 31.3596 30.1895 21.3742 24.9314 20.3125C25.1046 21.6089 25.1046 30.4153 14.7057 29.5883Z",
    fill: "#73314F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7048 29.5906C13.653 29.4952 12.5936 29.5214 11.5477 29.6688C11.3857 28.1042 11.5477 19.5102 21.7455 20.3316C22.8108 20.4262 23.8834 20.3962 24.9417 20.2422C25.0982 21.7844 24.9305 30.4176 14.7048 29.5906Z",
    fill: "#F1EBEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7847 20.4062C28.2051 20.9202 33.3068 17.5731 33.3068 9.59375C25.0927 11.8289 14.1741 8.95115 9.37422 12.1362C-0.437971 18.6348 6.28975 28.6146 11.5479 29.6763C11.4026 28.38 11.3802 19.5792 21.7847 20.4062Z",
    fill: "#275C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/AppLogo.9bc6b013e72edbbd21d164bee2b8ca58.svg";
export { ForwardRef as ReactComponent };